<template lang="pug">
	.main
			.poster
				.wrapper.wrapper_full
					swiper.poster__swiper(v-if="slides.length" :options="swiperPosterOption")
						swiperSlide(v-for="(card, index) in slides" :key="index")
							.poster__bg(:style="{backgroundImage: 'url(\"'+ ((desk && card.photo) ? card.photo[1200] : card.photo_mobile ? card.photo_mobile : card.photo[1200]) +'\")'}" data-aos="fade")
							.poster__outer
								.poster__inner
									.wrapper
										.poster__content(data-aos="fade-up" data-aos-delay="500")
											.poster__info
												.poster__subtitle( v-if="card.sub_title != ''") {{ card.sub_title}}
												.poster__title(v-text="card.name")
												.poster__text
													span.text {{ card.description }}
												a.poster__btn(
													:href="card.url"
													target="_blank"
													v-if="card.url.includes('http') && card.button_text") {{ card.button_text }}
													span
												router-link.poster__btn(:to="card.url" v-else-if="card.url && card.button_text") {{ card.button_text }}
													span
					template(v-if="slides.length > 1")
						button.poster__arrow.poster__arrow_left(data-aos="fade-up" data-aos-delay="500")
						button.poster__arrow.poster__arrow_right(data-aos="fade-up" data-aos-delay="500")
						.poster__pagination(data-aos="fade-up" data-aos-delay="500")
						.poster__counter(data-aos="fade-up" data-aos-delay="500")
							span
							
							
			.section.section_products
				template(v-if="getNewProductsForIndex.length")
					.wrapper
						.section__title(data-aos="fade-up") Новинки
						.section__swiper-container.section__swiper-container_1(data-aos="fade-up" data-aos-delay="200")
							.section__swiper-wrapper
								swiper.section__swiper(v-if="showSliders && getNewProductsForIndex.length" :options="{allowTouchMove: false,loop: (newProducts.length > 4 ? true : false),slidesPerView: 4,breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true, loop: true}}}" ref="swiper3")
									swiperSlide(
										v-for="(card, index) in getNewProductsForIndex"
										:key="index"
									)
										section-card(
											:card="card"
											:type="'product'"
											:link="'/products/' + (getCatalogById(card.catalogs[0]) ? getCatalogById(card.catalogs[0]).slug : '') + '/' + card.slug + '/'"
										)
							template(v-if="getNewProductsForIndex.length > 4")
								button.section__arrow.section__arrow_left( @click="slidePrev('3')")
								button.section__arrow.section__arrow_right( @click="slideNext('3')")
				template(v-if='getProductsForIndex.length')
					.wrapper
						.section__title(data-aos="fade-up") Топ продукти FMC
						.section__swiper-container.section__swiper-container_1(data-aos="fade-up" data-aos-delay="200")
							.section__swiper-wrapper
								swiper.section__swiper(v-if="showSliders" :options="{allowTouchMove: false,loop: (getProductsForIndex.length > 4 ? true : false),slidesPerView: 4,breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true, loop: true}}}" ref="swiper1")
									swiperSlide(
										v-for="(card, index) in getProductsForIndex"
										:key="index"
									)
										section-card(
											:card="card"
											:type="'product'"
											:link="'/products/' + (getCatalogById(card.catalogs[0]) ? getCatalogById(card.catalogs[0]).slug : '') + '/' + card.slug + '/'"
										)
							template(v-if="getProductsForIndex.length > 4")
								button.section__arrow.section__arrow_left( @click="slidePrev('1')")
								button.section__arrow.section__arrow_right( @click="slideNext('1')")
				template(v-if='getProductsForIndex.length || getNewProductsForIndex.length')
					.section__bottom(data-aos="fade-up")
						router-link.section__more(to='/products/') Всі продукти
							span

			.section.section_sec(data-aos="fade-up")
				.wrapper
					.apps
						.apps__inner
							.apps__content
								.apps__subtitle(v-text="settings.app_subtitle")
								.apps__title(v-text="settings.app_title")
								.apps__text(v-html="settings.app_content")
							img.apps__img(src="@/assets/img/apps.png")
							.apps__list
								a.apps__item(v-if="settings.app_link_ios" :href="settings.app_link_ios" target="_blank" @click="sendAnalyticIos")
									img(src="@/assets/img/app1.svg")
								a.apps__item(v-if="settings.app_link_android" :href="settings.app_link_android" target="_blank" @click="sendAnalyticAndroid")
									img(src="@/assets/img/app2.svg")
					.apps.apps_mobile
						.apps__inner
							.apps__subtitle(v-text="settings.app_subtitle")
							.apps__title(v-text="settings.app_title")
							.apps__text(v-html="settings.app_content")
							.apps__content
								img.apps__img(src="@/assets/img/apps.png")
								.apps__list
									a.apps__item(v-if="settings.app_link_ios" :href="settings.app_link_ios" target="_blank"  @click="sendAnalyticIos")
										img(src="@/assets/img/app1.svg")
									a.apps__item(v-if="settings.app_link_android" :href="settings.app_link_android" target="_blank" @click="sendAnalyticAndroid")
										img(src="@/assets/img/app2.svg")
			.section.section_th.section_promo(v-if="getPromosForIndex.length > 0")
				.wrapper
					.section__title(data-aos="fade-up") Увага акція!
					.slider
						.slider__container.slider__container_desk( v-if="desk")
							swiper.slider__swiper(v-if="showSliders" :options="swiperSliderOption" ref="swiper2")
								swiperSlide(v-for="(card, index) in getPromosForIndex" :key="index")
									.slider__img(data-aos="fade" :style="{backgroundImage: 'url(\"'+ (card.photo ? card.photo[800] : '') +'\")'}")
									.slider__content(data-aos="fade-up" data-aos-delay="200")
										.slider__subtitle(v-text="getDate(card.date)")
										.slider__title(v-text="card.name")
										.slider__text(v-html="card.short_description")
										router-link.slider__btn(:to="'/promos/' + card.slug + '/'") Більше
											span
							template
								.slider__pagination(data-aos="fade-up" data-aos-delay="500")
								.slider__counter
						.slider__container.slider__container_mob(v-else)
							swiper.slider__swiper(v-if="showSliders" :options="swiperSliderOption" ref="swiper2")
								swiperSlide(v-for="(card, index) in getPromosForIndex" :key="index")
									div
										.slider__img(data-aos="fade" :style="{backgroundImage: 'url(\"'+ (card.photo ? card.photo[800] : '') +'\")'}")
										.slider__content(data-aos="fade-up" data-aos-delay="200")
											.slider__subtitle(v-text="getDate(card.date)")
											.slider__title(v-text="card.name")
											.slider__text(v-html="card.short_description")
											router-link.slider__btn(:to="'/promos/' + card.slug + '/'") Більше
												span
							template
								button.slider__arrow.slider__arrow_left(data-aos="fade-up" data-aos-delay="500")
								button.slider__arrow.slider__arrow_right(data-aos="fade-up" data-aos-delay="500")
								.slider__pagination
								.slider__counter
			.section.section_video
				.wrapper
					.section__title(data-aos="fade-up") Нові відео
					.section__swiper-container.section__swiper-container_2(data-aos="fade-up" data-aos-delay="200" )
						.section__swiper-wrapper
							swiper.section__swiper(v-if="videos.filter(v => v.show_on_index == true).slice(0, 10).length" :options="{allowTouchMove: false, loop: (videos.filter(v => v.show_on_index == true).slice(0, 10).length > 3 ? true : false), slidesPerView: 3, breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true, loop: true}}}"  ref="swiperV")
								swiperSlide(
									v-for="(card, index) in videos.filter(v => v.show_on_index == true).slice(0, 10)"
									:key="index"
								)
									section-card(
										:card="card"
										:type="'video'"
										:link="'/video/' + card.slug + '/'"
									)
						template(v-if="videos.filter(v => v.show_on_index == true).slice(0, 10).length > 3")
							button.section__arrow.section__arrow_left( @click="slidePrev('v')")
							button.section__arrow.section__arrow_right( @click="slideNext('v')")
					.section__bottom(data-aos="fade-up")
						router-link.section__more(to='/video/') Всі відео
							span
</template>

<script>

	import BlockHeader from '@/blocks/includes/header.vue';
	import BlockFooter from '@/blocks/includes/footer.vue';
	import sectionCard from '@/components/sectionCard.vue';
	import appBanner from '@/components/appBanner.vue';

	import 'swiper/dist/css/swiper.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper';
	import {mapState, mapGetters} from 'vuex';
	import AOS from 'aos';

	export default {
		name: 'Main',
		metaInfo: function() {
			return {
				title: 'Головна',
			}
		},
		data: function(){
			return {
				showSliders: true,
				swiperPosterOption: {
					allowTouchMove: false,
					loop: true,
					effect: 'fade',
					autoHeight: true,
					autoplay: {
						delay: 7000,
					},
					fadeEffect: {
						crossFade: true
					},
					pagination: {
						el: '.poster__pagination',
						type: 'bullets',
						clickable: true
					},
					navigation: {
						nextEl: '.poster__arrow_right',
						prevEl: '.poster__arrow_left'
					},
					on: {
						slideChange() {
							let el = document.querySelector('.poster__counter span');
							let i = this.realIndex+1;
							if (el) el.innerText = i < 10 ? '0' + i : i;
						}
					}
				},
				swiperSliderOption: {
					allowTouchMove: false,
					rewind: true,
					autoHeight: true,
					pagination: {
						el: '.slider__pagination',
						type: 'bullets',
						clickable: true
					},
					effect: 'fade',
					autoplay: {
						delay: 7000,
					},
					fadeEffect: {
						crossFade: true
					},
					navigation: {
						nextEl: '.slider__arrow_right',
						prevEl: '.slider__arrow_left'
					},
					on: {
						slideChange() {
							let el = document.querySelector('.slider__counter span');
							let i = this.realIndex+1;
							if (el) el.innerText = i < 10 ? '0' + i : i;
						}
					}
				}
			}
		},
		created() {
			if (!this.promos.length) this.$store.dispatch('GET_COLLECTION', 'promos');
			if (!this.slides.length) this.$store.dispatch('GET_COLLECTION', 'slides');
			if (!this.videos.length) this.$store.dispatch('GET_COLLECTION', 'videos');
			if (!this.products.length) this.$store.dispatch('GET_COLLECTION', 'products');
			if (!this.newProducts.length) this.$store.dispatch('GET_NEW_PRODUCTS', 'newProducts');
			if (!this.catalogs.length) this.$store.dispatch('GET_COLLECTION', 'catalogs');
		},
		mounted() {
			this.resizeHandler();
			window.addEventListener('resize', this.resizeHandler, false);

			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
				this.resizeHandler();
			})
		},
		updated() {
			this.resizeHandler();
		},
		methods: {
			resizeHandler() {
				setTimeout(() => {
					if (this.$refs.swiper1) this.$refs.swiper1.swiper.update();
					if (this.$refs.swiper2) this.$refs.swiper2.swiper.update();
					if (this.$refs.swiper3) this.$refs.swiper3.swiper.update();
				}, 1000);
			},
			getDate(date) {
				let d = new Date(date);
				var dd = d.getDate();
				var mm = d.getMonth() + 1;

				var yyyy = d.getFullYear();
				if (dd < 10) {
					dd = '0' + dd;
				}
				if (mm < 10) {
					mm = '0' + mm;
				}
				return dd + '.' + mm + '.' + yyyy;
			},
			slideNext(id) {
				if(id == '1') this.$refs.swiper1.swiper.slideNext();
				if(id == '3') this.$refs.swiper3.swiper.slideNext();
				if(id == 'v') this.$refs.swiperV.swiper.slideNext();
			},
			slidePrev(id) {
				if(id == '1' ) this.$refs.swiper1.swiper.slidePrev();
				if(id == '3' ) this.$refs.swiper3.swiper.slidePrev();
				if(id == 'v' ) this.$refs.swiperV.swiper.slidePrev();
			},
      sendAnalyticAndroid() {
        dataLayer.push({
          'eventCategory': 'application',
          'eventAction': 'Click',
          'eventLabel': 'app_android',
          'event': 'app_android'
        });
      },
      sendAnalyticIos() {
        dataLayer.push({
          'eventCategory': 'application',
          'eventAction': 'Click',
          'eventLabel': 'app_ios',
          'event': 'app_ios'
        });
      },
		},
		computed: {
			...mapState([
				'promos',
				'slides',
				'videos',
				'settings',
				'products',
				'newProducts',
				'catalogs',
				'withBanner',
				'desk',
			]),
			...mapGetters([
				'getPromosForIndex',
				'getProductsForIndex',
				'getNewProductsForIndex',
				'getCatalogById'
			]),
		},
		components: {
			'block-header': BlockHeader,
			'block-footer': BlockFooter,
			'section-card': sectionCard,
			swiper,
      appBanner,
			swiperSlide
		}
	}

</script>

<style lang="scss">
	@import '@/assets/sass/ui.scss';
	@import '@/helpers/sass/aos.scss';
</style>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';
	.swiper-slide-active {
		z-index: 2;
	}

	.poster {
		height: 518px;
		position: relative;

		.wrapper {
			height: 100%;		
		}

		&__swiper {
			height: 100%;

			&_desk {
				display: block;
			}

			&_mob {
				display: none;
			}
		}

		&__bg {
			position: absolute;
			height: 100%;
			width: calc(100% - 325px - 80px);
			left: 0;
			top: 0;
			background-size: cover;
			background-position: center;
		}

		&__outer {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			font-size: 0;
			text-align: right;

			&:before {
				content: "";
				display: inline-block;
				vertical-align: middle;
				height: 100%;
			}
		}

		&__content {
			background-color: #fff;
			width: 630px;
			display: inline-block;
			position: relative;
			padding: 81px 70px 81px 107px;
			text-align: left;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.05);
		}

		&__inner {
			display: inline-block;
			vertical-align: middle;
			width: 100%;
			margin-top: -50px;
		}

		&__subtitle {
			@include kit('featureSubtitle');
		}

		&__title {
			@include kit('featureTitle');
		}

		&__text {
			@include kit('featureText');
		}

		&__btn {
			position: absolute;
			top: 100%;
			right: -50px;
			height: 50px;
			width: 247px;
			background-color: #EF3E33;
			text-align: center;
			padding-right: 50px;
			font: 500 19px/50px 'Helvetica', Arial, sans-serif;
			color: #fff;
			text-transform: uppercase;
			letter-spacing: 1px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);



			&:after {
				content: "";
				display: block;
				position: absolute;
				width: calc(100% - 50px);
				height: 100%;
				top: 0;
				left: 0;
				box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);
			}

			&:before {
				position: absolute;
				content: '';
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				background-color: rgba(255,255,255,.3);
				opacity: 0;
				pointer-events: none;
			}

			span {
				position: absolute;
				top: 0;
				right: 0;
				height: 100%;
				width: 50px;
				background: url('../assets/img/arr_1.svg') no-repeat center center;
			}

			@media screen and (min-width: 1201px) {
				&:hover {
					&:before {
						opacity: 1;
						transition: opacity .3s ease;
					}
				}
			}
		}

		&__arrow {
			position: absolute;
			top: 209px;
			width: 50px;
			height: 50px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			background-color: #EF3E33;
			z-index: 1;

			&:before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-color: rgba(255,255,255,.3);
				opacity: 0;
				pointer-events: none;
			}

			&_left {
				background: url('../assets/img/arr_2.svg') #EF3E33 no-repeat center center;
				left: calc(50% - 40px);
			}

			&_right {
				background: url('../assets/img/arr_1.svg') #EF3E33 no-repeat center center;
				left: calc(50% + 10px);
			}

			@media screen and (min-width: 1201px) {
				&:hover {

					&:before {
						opacity: 1;
						transition: opacity .3s ease;
					}
				}
			}
		}

		&__pagination {
			position: absolute;
			bottom: 70px;
			width: 305px;
			text-align: center;
			z-index: 1;
			left: calc(50% + 10px);
			font-size: 0;

			>>> span {
				display: inline-block;
				vertical-align: top;
				border-radius: 0;
				opacity: 1;
				width: 10px;
				height: 10px;
				border: 1px solid #fff;
				margin: 0 15px;
				background-color: transparent;
				transition: background-color .5s ease;
				cursor: pointer;
				outline: none;

				&.swiper-pagination-bullet-active {
					background-color: #fff;
				}
			}
		}

		&__counter {
			position: absolute;
			left: calc(50% + 640px);
			top: 208px;
			z-index: 1;
			text-shadow: 0px 12px 20px rgba(51, 51, 51, 0.2);
			font: 900 71px/82px 'Helvetica', Arial, sans-serif;
			color: #fff;
			display: block;

			span {
				display: block;
				transform: translateX(-50%);
			}
		}
	}

	.section {
		margin: 94px 0;

		&_products {
			.section__arrow {
				top: 50px;
			}
		}

		.wrapper {
			margin-bottom: 35px;
		}

		&__title {
			@include kit('sectionTitle');
			margin-left: 0;
		}

		&__swiper {
			width: calc(100% + 20px);
			margin-left: -10px;
		}

		&__swiper-container {
			position: relative;
			margin-top: 0;
		}

		&__swiper-wrapper {
			width: 100%;
			height: 100%;
			overflow: hidden;
		}

		&__arrow {
			position: absolute;
			top: 50px;
			width: 50px;
			height: 50px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			background-color: #EF3E33;
			z-index: 0;

			&_left {
				background: url('../assets/img/arr_2.svg') #EF3E33 no-repeat center center;
				left: -49px;
			}

			&_right {
				background: url('../assets/img/arr_1.svg') #EF3E33 no-repeat center center;
				right: -49px;
			}


		}

		>>> .card {
			margin-bottom: 57px;
			margin-top: 20px;
		}

		&__bottom {
			text-align: center;
			position: relative;
			z-index: 1;
		}

		&__more {
			height: 50px;
			width: 296px;
			max-width: 100%;
			border: 1px solid #EF3E33;
			position: relative;
			display: inline-block;
			vertical-align: top;
			text-transform: uppercase;
			margin-top: -6px;
			padding-right: 50px;
			text-align: center;
			color: #EF3E33;
			font: 500 19px/52px 'Helvetica', Arial, sans-serif;
			letter-spacing: 2px;
			position: relative;

			span {
				display: block;
				position: absolute;
				top: 0;
				right: 0;
				width: 50px;
				height: 100%;
				background: url('../assets/img/arr_3.svg') no-repeat center center;
				border-left: 1px solid #EF3E33;
			}
		}

		&_video {

			margin-bottom: 100px;

			.section__swiper-container {
				margin-bottom: -40px;
			}


		}
	}

	.apps {
		margin: 124px 0 193px;

		&_mobile {
			display: none;
		}

		&__inner {
			background-color: #fff;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.05);
			padding: 84px 0 69px 107px;
			position: relative;
		}

		&__img {
			position: absolute;
			width: 50%;
			max-width: 630px;
			right: 0;
			top: 50%;
			transform: translateY(-44%);
		}

		&__content {
			max-width: 50%;
		}

		&__subtitle {
			@include kit('featureSubtitle');
		}

		&__title {
			@include kit('featureTitle');
		}

		&__text {
			@include kit('featureText');
			height: 62px;
			overflow: hidden;
		}

		&__list {
			position: absolute;
			bottom: 100%;
			left: 0;
			font-size: 0;
		}

		&__item {
			display: inline-block;
			vertical-align: top;
			margin-right: 20px;
			transition: opacity .5s ease;

			@media screen and (min-width: 1201px) {
				&:hover {
					opacity: .7;

				}
			}

			img {
				max-width: 88px;
			}
		}
	}

	.slider {
		&__container {
			margin-top: 36px;
			margin-bottom: 144px;
			position: relative;

			&_desk {
				display: block;
			}

			&_mob {
				display: none;
			}
		}


		>>> .swiper-container {
			overflow: visible;
			padding:0
		}

		&__swiper {
			height: 468px;
		}

		&__subtitle {
			@include kit('featureSubtitle');
		}

		&__title {
			@include kit('featureTitle');

		}

		&__text {
			@include kit('featureText');
		}

		&__img {
			height: 100%;
			width: 650px;
			background-size: cover;
			background-position: center;
			background-color: #555;
		}

		&__content {
			height: 368px;
			width: calc(100% - 650px);
			position: absolute;
			right: 0;
			top: 50px;
			background-color: #fff;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.05);
			padding: 84px 108px 0px 108px;
		}

		&__pagination {
			position: absolute;
			bottom: 20px;
			width: 305px;
			text-align: left;
			z-index: 1;
			left: 650px;
			font-size: 0;
			padding-left: 108px;

			>>> span {
				display: inline-block;
				vertical-align: top;
				border-radius: 0;
				opacity: 1;
				width: 10px;
				height: 10px;
				border: 1px solid #EF3E33;
				margin-right: 30px;
				background-color: transparent;
				transition: background-color .5s ease;
				cursor: pointer;
				outline: none;

				&.swiper-pagination-bullet-active {
					background-color: #EF3E33;
				}
			}
		}

		&__counter {
			position: absolute;
			left: calc(50% + 640px);
			top: 208px;
			z-index: 1;
			text-shadow: 0px 12px 20px rgba(51, 51, 51, 0.2);
			font: 900 71px/82px 'Helvetica', Arial, sans-serif;
			color: #fff;
			transform: translateX(-50%);
		}

		&__btn {
			position: absolute;
			top: 100%;
			right: -50px;
			height: 50px;
			width: 247px;
			background-color: #EF3E33;
			text-align: center;
			padding-right: 50px;
			font: 500 19px/50px 'Helvetica', Arial, sans-serif;
			color: #fff;
			text-transform: uppercase;
			letter-spacing: 1px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);

			&:after {
				content: "";
				display: block;
				position: absolute;
				width: calc(100% - 50px);
				height: 100%;
				top: 0;
				left: 0;
				box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);
			}

			span {
				position: absolute;
				top: 0;
				right: 0;
				height: 100%;
				width: 50px;
				background: url('../assets/img/arr_1.svg') no-repeat center center;


			}
		}

		&__arrow {
			position: absolute;
			top: 209px;
			width: 50px;
			height: 50px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			background-color: #EF3E33;
			z-index: 1;

			&:before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-color: rgba(255,255,255,.3);
				opacity: 0;
				pointer-events: none;
			}

			&_left {
				background: url('../assets/img/arr_2.svg') #EF3E33 no-repeat center center;
				left: calc(50% - 40px);
			}

			&_right {
				background: url('../assets/img/arr_1.svg') #EF3E33 no-repeat center center;
				left: calc(50% + 10px);
			}

			@media screen and (min-width: 1201px) {
				&:hover {

					&:before {
						opacity: 1;
						transition: opacity .3s ease;
					}
				}
			}
		}
	}

	>>> .swiper-container-autoheight {
		.swiper-slide {
			height: 100%;
		}
	}

	>>> .swiper-container {
		padding: 30px 0;
	}

	.poster {
		>>> .swiper-container {
			padding: 0;
		}
	}

	@media screen and (max-width: 1200px) {
		.poster {
			height: auto;

			.wrapper {
				padding: 0;
			}

			&__text {
				.text {
					line-height: 1.24;
				}
			}

			&__pagination {
				bottom: auto;
				top: 323px;
				left: 20px;
				width: auto;

				>>> span {
					margin: 0;
					margin-right: 30px;
				}
			}

			&__arrow {
				top: 303px;

				&_left {
					left: auto;
					right: 70px;
				}

				&_right {
					left: auto;
					right: 20px;
				}


			}

			&__bg {
				height: 374px;
				width: 100%;
				left: 0;
			}

			&__content {
				display: block;
				margin-top: 300px;
				width: calc(100% - 40px);
				margin-left: 0;
				// height: 150px;
				margin-left: 20px;
				padding: 30px;
			}

			&__info {
				// padding: 0 20px;
			}

			&__outer {
				position: relative;
				height: auto;
			}

			&__inner {
				margin-bottom: 50px;
        margin-top: 53px;

				.wrapper {
					max-width: 100%;
					padding: 0;
				}
			}

			&__btn {
				right: 0;
				padding: 0 20px;
				text-align: center;
				width: auto;


				span {
					display: none;
				}


			}

			&__swiper {
				&_desk {
					display: none;
				}

				&_mob {
					display: block;
				}
			}

			>>> .swiper-container {
				overflow: visible;
			}
		}

		.section {
			&__arrow {
				display: none;
			}

			&__more {
				margin-top: 24px;
			}

			.section__swiper-container {
				width: calc(100% + 40px);
				margin-left: 0px;
			}

			>>> .swiper-slide {
				padding: 0 10px;
				width: 266px;
			}

			>>> .card {
				width: 246px;
				margin: 0;
			}

			&_promo {
				.section__title {
					margin-bottom: 0;
					margin-bottom: -30px;
				}
			}
		}

		.apps {
			display: none;

			&__list {
				height: 44px;
				box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.3);
			}

			&_mobile {
				display: block;
			}

			&__inner {
				background-color: transparent;
				padding: 0;
				width: 100%;
				box-shadow: none;
			}

			&__content {
				background-color: #fff;
				height: 274px;
				width: 100%;
				position: relative;
				top: 0;
				left: 0;
				max-width: none;
				margin-top: 233px;
				box-shadow: 0 12px 20px rgba(51, 51, 51, 0.05);
				z-index: 1;
			}

			&__text {
				height: auto;
			}

			&__list {
				top: 100%;
				height: 30px;
			}

			&__img {
				height: 424px;
				width: auto;
				right: auto;
				left: 50%;
				top: auto;
				bottom: 42px;
				transform: translateX(-50%);
			}

			&__item {
				margin-right: 0;

				img {
					max-width: none;
					height: 30px;
				}
			}
		}

		.section {
			margin-top: 44px;

			&_sec {
				margin-top: -25px;
			}

			&_th {
				margin-top: -15px;
				margin-bottom: 0;
			}

			&_video {
				margin-top: 39px;

				.section__swiper-container {
					margin-bottom: 0px;
				}

				.section__title {
					margin-bottom: -11px;
				}

			}

			>>> .card_video {
				.card__bg {
					height: 139px;
				}
			}

			&__title {
				margin-bottom: 10px;
			}
		}

		.slider {
			// width: calc(100% + 40px);
			// margin-left: -20px;

			&__btn {
				width: auto;
				right: 0;
				padding: 0 20px;
				text-align: center;
				transition: opacity .3s ease!important;

				span {
					display: none;
				}


			}

			>>> .swiper-container {
				padding-bottom: 90px;
				padding-top: 30px;
			}

			>>> .swiper-slide {
				padding: 0;
			}

			&__img {
				height: 335px;
				width: 100%;
			}

			&__content {
				position: relative;
				top: 0;
				left: 0;
				width: 100%;
				padding: 20px;
				height: auto;
			}

			&__title {
				margin-top: 28px;
			}

			&__text {
				margin-top: 19px;
			}

			&__container {
				margin-top: 20px;
				margin-bottom: 0;

				&_desk {
					display: none;

				}

				&_mob {
					display: block;
				}
			}

			&__swiper {
				height: auto;
			}

			&__arrow {
				top: 315px;

				&_left {
					left: auto;
					right: 50px;
				}

				&_right {
					left: auto;
					right: 0px;
				}


			}

		}

		>>> .swiper-container-autoheight {
			.swiper-slide {
				height: auto;
			}
		}
	}

	// @media(max-width: 960px) {
	// 	.poster {
	// 		&__content {
	// 			height: 170px;
	// 		}

	// 	}
	// }

	@media(max-width: 650px) {
		.poster {

			&__content {
				// height: 260px;
			}
			&__title {
				// white-space: normal;
				// height: 68px;
			}
			&__text {
				// max-height: 125px;
				position: relative;
			}
		}

		.text {
			display: inline-block;
			vertical-align: bottom;
		}

		.rect {
			display: inline-block;
			width: 5px;
			height: 5px;
		}

		.ellipsis {
			display: inline-block;
			position: absolute;
			bottom: 0;
			right: 0;
			opacity: 0;
			background-color: red;




			// &:before {
			// 	content: '';
			// 	position: absolute;
			// 	top: 0;
			// 	left: 0;
			// 	width: 100%;
			// 	height: 100%;
			// 	background-color: #fff;
			// }


		}
	}

	@media screen and (max-width: 325px) {
		.apps {
			&__list {
				height: 34px;
			}
			&__item {
				width: auto;
				height: 34px;

				img {
					width: auto;
					height: 100%;
				}
			}
		}
	}

</style>
